import React from 'react';
import MobileSwiper from 'components/MobileSwiper/MobileSwiper';
import { Product } from '@inter-ikea-storageone/range';
import { NoneOption } from 'rangeConfig/@types';

type Props = {
  onLayoutSelected: (layout: Product) => void;
  selectedLayout: string;
  suggestionsForSelectedFrame: Product[];
  noneOption?: NoneOption;
};

const FrontLayoutsSwiper = ({
  noneOption,
  onLayoutSelected,
  selectedLayout,
  suggestionsForSelectedFrame
}: Props) => {
  return (
    <MobileSwiper
      id="front-layout-products-swiper"
      onSelect={onLayoutSelected}
      noneOption={noneOption}
      numberOfItems={10}
      selectedIds={[selectedLayout]}
      productClusters={suggestionsForSelectedFrame.map(p => [p])}
      showInfoButton={false}
    />
  );
};

export default FrontLayoutsSwiper;
